import script from "./MultiMenu.vue?vue&type=script&setup=true&lang=ts"
export * from "./MultiMenu.vue?vue&type=script&setup=true&lang=ts"

import "./MultiMenu.scss?vue&type=style&index=0&id=26e552a7&scoped=true&lang=scss&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-26e552a7"]])

export default __exports__